import { useFlag } from "../optimizely";
import { usePermissions } from "./use-permissions";

/**
 * Whether the data on screen is a reviewer's, and so comes from the reviewer schema. A reviewer is
 * granted none of the tables the rest of the app reads, so this is what picks the way in.
 */
export function useReviewerSchema(): boolean {
  const { reviewer } = usePermissions();
  const [reviewExperienceEnabled] = useFlag("reviewer_role");

  return reviewExperienceEnabled && reviewer;
}
